import type { FaireProductEntity } from "../../entity_types/product";

export const p_qf73gszqes: FaireProductEntity = {
  token: "p_qf73gszqes",
  type: "product",
  name: "Forest Water Sparkling Botanical Soda | Sample Pack 4-pack",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/e7f073ce3b0f416046a191c754017580fa3032c92afe96c43e04555a9ae5d180.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a93bfe43ccef55296c75a05fe8d02bd5fe0b7649a33d1d5be927658075b63d53.png",
    "https://cdn.faire.com/fastly/3b4d2756ce25533669c8508c7a93238c7a3c6c5dca502549fdc6ab0cf9919537.jpeg"
  ],
  priceDollars: 2.25,
  description: "Sample our botanical non-alc sparkling botanical soda, Forest Water. Forest Water is our take on an Amaro soda, made using upcycled kombucha vinegar which extracts flavors from foraged botanicals inspired by the biodiverse region of Appalchia. That is then blended with water and carbonated, resulting in a lightly sweet, complex botanical tonic. This four pack allows for a low-investment way to the two flavors in this product line: Alpine and Meadow.\n\nSample 4-Pack Contents:\n2 x 12 oz cans of Alpine (bitter & woodsy)\n2 x 12oz cans of Meadow (floral & delicate)\n\nFrom the creators of Walker Brothers kombucha \n\n\n\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:43.312Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
